import React from 'react';
import { useNavigate } from 'react-router-dom';

const NotFound = () => {
  const navigate = useNavigate();
  const currentLanguage = localStorage.getItem('siteLanguage');

  const getLocalizedText = (persianText, arabicText) => {
    return currentLanguage === 'ar' ? arabicText : persianText;
  };

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      height: '70vh',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div style={{ fontSize: '120px', marginBottom: '20px' }}>🔍</div>
      
      <h1 style={{
        fontSize: '48px',
        color: '#dc2626',
        marginBottom: '10px'
      }}>
        404
      </h1>
      
      <h2 style={{
        fontSize: '24px',
        color: '#374151',
        marginBottom: '20px'
      }}>
        {getLocalizedText('صفحه یافت نشد', 'الصفحة غير موجودة')}
      </h2>
      
      <p style={{
        fontSize: '16px',
        color: '#6b7280',
        marginBottom: '30px',
        maxWidth: '500px',
        lineHeight: '1.6'
      }}>
        {getLocalizedText(
          'صفحه‌ای که دنبال آن می‌گردید وجود ندارد یا ممکن است جابجا شده باشد.',
          'الصفحة التي تبحث عنها غير موجودة أو ربما تم نقلها.'
        )}
      </p>
      
      <div style={{ display: 'flex', gap: '15px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <button
          onClick={() => navigate('/home')}
          style={{
            background: 'linear-gradient(135deg, #1a5f3f 0%, #22543d 100%)',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '25px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          {getLocalizedText('بازگشت به خانه', 'العودة إلى الصفحة الرئيسية')}
        </button>
        
        <button
          onClick={() => navigate(-1)}
          style={{
            background: 'linear-gradient(135deg, #6b7280 0%, #4b5563 100%)',
            color: 'white',
            border: 'none',
            padding: '12px 24px',
            borderRadius: '25px',
            cursor: 'pointer',
            fontWeight: '600',
            fontSize: '16px'
          }}
        >
          {getLocalizedText('بازگشت', 'رجوع')}
        </button>
      </div>
    </div>
  );
};

export default NotFound;